import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmService } from '../../services/confirm.service';

@Component({
  selector: 'wg-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (confirmService.active(); as req) {
      <div class="modal-overlay" (click)="confirmService.decide(false)">
        <div class="modal-panel fade-up" style="width: 420px" (click)="$event.stopPropagation()">
          <h2 class="confirm-title">{{ req.title }}</h2>
          <p class="confirm-message">{{ req.message }}</p>
          <div class="confirm-actions">
            <button class="btn btn-secondary" (click)="confirmService.decide(false)">Cancel</button>
            <button class="btn btn-danger-solid" (click)="confirmService.decide(true)">
              {{ req.confirmLabel }}
            </button>
          </div>
        </div>
      </div>
    }
  `,
  styles: [`
    .confirm-title { font-size: 16px; font-weight: 700; margin-bottom: 6px; }
    .confirm-message { font-size: 13.5px; color: var(--text-2); line-height: 1.55; }
    .confirm-actions { display: flex; gap: 8px; justify-content: flex-end; margin-top: 20px; }
  `],
})
export class ConfirmDialogComponent {
  readonly confirmService = inject(ConfirmService);
}
